// @ts-nocheck

import { Options, Vue } from 'vue-class-component'
import { authService } from '@/http/auth'
import roleAccessManager from '@/utils/role-access-manager'
import router from '@/router/index'

@Options({
  data () {
    return {
      data: {
        instance: this.$route.params.instance,
        email: this.$route.params.email,
        role_id: this.$route.params.role_id,
        signature: this.$route.params.signature,
        child_user_id: '',
        route: '',
        child_list: []
      },
      form: {
        email: '',
        password: '',
        instance: '',
        role_id: '',
        child_user_id: ''
      },
      failed: false,
      failedLogin: false
    }
  },
  methods: {
    handleSubmit: async function () {
      await Promise.all([
        authService.authLogin(this.form)
      ]).then(results => {
        if (results[0] == false) {
          this.failedLogin = true
        } else {
          const user = JSON.parse(localStorage.getItem('user') || '{}')
          const active_role_id = user.active_role_id
          localStorage.setItem('instance', this.form.instance)
          if (active_role_id == 4 || active_role_id == 5) {
            localStorage.setItem('default_dashboard_path', '/user/bill')
            router.replace({ path: '/user/bill' })
          } else {
            let route = '/'
            localStorage.setItem('default_dashboard_path', route)
            if (this.data.route) {
              route = this.data.route
            }
            router.replace({ path: route })
          }
        }
      }).catch((e) => {
        this.failed = true
        console.log(e)
      })
    },
    checkChild: async function () {
      // make sure form.email and form.password and form.instance and form.role_id is not empty
      if (this.form.email && this.form.password && this.form.instance && this.form.role_id && this.form.role_id == 5) {
        await Promise.all([
          authService.checkChild(this.form)
        ]).then(results => {
          if (results[0].data.child_list.length > 0) {
            this.data.child_list = results[0].data.child_list
          }
        }).catch((e) => {
          this.failed = true
          console.log(e)
        })
      }
    }
  },
  async mounted () {
    if (this.data.instance != undefined && this.data.email != undefined && this.data.role_id != undefined && this.data.signature != undefined) {
      if (this.$route.query.child_user_id) {
        this.data.child_user_id = this.$route.query.child_user_id
      }

      if (this.$route.query.route) {
        this.data.route = this.$route.query.route
      }

      await Promise.all([
        authService.token(this.data)
      ]).then(results => {
        // redirect ke user / admin sesuai dengan role id
        if (results[0] == false) {
          this.failed = true
        } else {
          const user = JSON.parse(localStorage.getItem('user') || '{}')
          const active_role_id = user.active_role_id
          localStorage.setItem('instance', this.data.instance)
          if (active_role_id == 4 || active_role_id == 5) {
            localStorage.setItem('default_dashboard_path', '/user/bill')
            router.replace({ path: '/user/bill' })
          } else {
            let route = '/'
            localStorage.setItem('default_dashboard_path', route)
            if (this.data.route) {
              route = this.data.route
            }
            router.replace({ path: route })
          }
        }
      }).catch((e) => {
        this.failed = true
        console.log(e)
      })
    } else {
      //destroy session dan localstorage
      localStorage.removeItem('user')
      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('instance')
      roleAccessManager.clearRoleAccess()
      
      this.failed = true
    }
  }
})
export default class Auth extends Vue {}
